import { Component, inject, Input, OnInit } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { Attachment, DocumentType } from '../../../models/attachment.model';
import { AttachmentPreviewManager } from '../../../managers/attachment-preview.manager';
import { SharedService } from '../../../services/shared.service';
import { AttachmentService } from '../../../services/attachment.service';
import { StateAmlCtfSanctions } from '../../../models/aml.model';
import { StateIndividual } from '../../../models/individual.model';
import { RegistrationApplicationForm } from '../../../../features/application/registration/models/registration-application-form.model';
import { ApplicationModel } from '../../../models/application.model';

@Component({
    selector: 'app-mlro-modal',
    templateUrl: './mlro-modal.component.html',
    styleUrls: ['./mlro-modal.component.scss'],
    standalone: false
})
export class MlroModalComponent implements OnInit {

  //@ts-ignore
  @Input() mlro: StateAmlCtfSanctions;
  @Input() application!: ApplicationModel<RegistrationApplicationForm>;

  isVisible: boolean = true;

  passport: Attachment | null = null;
  policies: Attachment | null = null;
  cv: Attachment | null = null;

  public readonly nzModalData: any = inject(NZ_MODAL_DATA);

  constructor(public modal: NzModalRef<MlroModalComponent>, 
    private attachmentService: AttachmentService,
    private shared: SharedService,
    private attachmentPreviewManager: AttachmentPreviewManager
  ) {

  }

  ngOnInit(): void {
    this.mlro = this.nzModalData.mlro;
    this.application = this.nzModalData.application;
    this.passport = this.attachmentService.attachments.find(i => i.documentType == DocumentType.AML_PASSPORT) || null;
    this.policies = this.attachmentService.attachments.find(i => i.documentType == DocumentType.AML_POLICIES) || null;
    this.cv = this.attachmentService.attachments.find(i => i.documentType == DocumentType.AML_CV) || null;
  }

  get individual(): StateIndividual | null {
    let individual = this.application!.form!.individuals!.find(ind => ind.id === this.mlro.mlroId);
    return individual || null;
  }

  get getContactNumberPrefix(): string | null {
    let country = this.shared.countries.find(c => c.isoCode3 == this.individual?.phoneCountryCode);
    if (country) {
      return country.phonePrefix;
    }
    return null;
  }

  get getMobNumberPrefix(): string  | null{
    let country = this.shared.countries.find(c => c.isoCode3 == this.mlro.officerMobNumberCountryCode);
    if (country) {
      return country.phonePrefix;
    }
    return null;
  }

  previewFile(att: Attachment) {
    this.attachmentPreviewManager.openPreview({ fileId: att.documentId, fileName: att.fileName, applicationId: att.backOfficeApplicationId});
  }

  get countryName(): string {
    let country = this.shared.countries.find(c => c.id == this.individual?.address?.country?.id);
    if (country) {
      return country.name;
    }
    else 
    {
      return '';
    }
  }
}
